@if (!!width() && height() ){
<google-map [height]="'100vh'" [width]='width()' #map [options]="options">
    @for (marker of localMarkers; track marker) {
    @if(marker.visible){
    <!-- With svgIcon -->
    @if(!!marker?.icon) {
    <map-advanced-marker #markerElem="mapAdvancedMarker" [title]="!!marker?.title ? marker.title : null "
        [position]="!!marker.lat && marker.visible ? { lat: marker?.lat, lng: marker?.lng } : null"
        [content]="marker.svgIcon" (mapClick)="showMarkerInfo(marker)">
    </map-advanced-marker>
    } @else {
    <!-- Without svgIcon, icon default -->
    <map-advanced-marker #markerElem="mapAdvancedMarker" [title]="!!marker?.title ? marker.title : null "
        [position]="!!marker.lat ? { lat: marker?.lat, lng: marker?.lng } : null" (mapClick)="showMarkerInfo(marker)">
    </map-advanced-marker>
    }
    }
    }
    <!-- En el componente del mapa -->
    <map-info-window #info (closeclick)="onInfoClose()">
        <ng-container *ngIf="selectedMarker">
            <ng-container
                *ngTemplateOutlet="getInfoWindowTemplate(selectedMarker); context: { $implicit: selectedMarker, members: selectedClusterMembers }"></ng-container>
        </ng-container>
    </map-info-window>
</google-map>
}

@if((mapsFacade.getMarkers$() | async)) {
<!-- This if force automatic refresh -->
}
<!-- Provider -->
<ng-template #templateProvider let-marker>
    <div class="card-marker overflowH" style="padding: 10px !important;">
        <div class="header-line full-width text-center mbs-1 pbs-1 pts-1">
            <!-- NAME -->
            <div class="flex-row flex-100 align-start-center gap-1em pxs-1">
                <span class="provider-state-chip flex-20" matTooltip="{{providerStatusTags[marker.status]}}"
                    [ngStyle]="{'color': PROVIDERS_STATUS_COLORS[marker.status], 'background-color': PROVIDERS_STATUS_BACKGROUND_COLORS[marker.status]}">
                    {{getStateLetter(marker.status)}}
                </span>
                <span class="card-text-primary name text-primary-darker subtitle-3 flex-70 text-wrap cursor-pointer"  (click)="showProviderNewTab(marker)">
                {{!!marker?.name
                    ?
                    marker.name : ('modules.providers.map.sin-nombre' | exp:'':'Sin nombre')}}</span>
            </div>
            <div class="flex-row align-end-center"
                [matTooltip]="marker.observations?.trim() || null">
                <span class="card-text-secondary"
                    [ngStyle]="{ 'color': marker.observations?.trim() ? 'var(--color-map-alert)' : 'var(--color-grey-medium)' }">
                    {{('modules.providers.map.observaciones' | exp:'':'Observaciones') }}
                </span>
                <mat-icon [style.width.px]="12" [style.height.px]="12" [svgIcon]="'Notepad'"
                    [ngStyle]="{ 'color': marker.observations?.trim() ? 'var(--color-map-alert)' : 'var(--color-grey-medium)' }">
                </mat-icon>
            </div>
        </div>
        <div class="flex flex-column align-center-center card-width gap-0-5em">
            <div class="flex-column gap-0-25em">
                <!-- DNI -->
                <span class="card-text text-body">{{('modules.providers.map.dni' | exp:'':'DNI')}} {{marker?.dni}}</span>
                <div class="flex-row align-center-center gap-0-25em">
                    <!-- SPECIALTY -->
                    <span class="card-text">{{specialtyName()}}</span>
                    <!-- PROFESSIONAL TYPE -->
                    <ng-container *ngFor="let specialty of marker?.specialties">
                        @if(specialty.id == specialtyId()) {
                            <span class="card-text"> - </span>
                            <span class="card-text" style="font-weight: 800 !important;">{{ specialty.specialtyProfessionalType?.name }}</span>
                        }
                    </ng-container>
                </div>
                <!-- MEDICAL LICENSE -->
                <div class="container">
                    <ng-container *ngFor="let specialty of marker?.specialties">
                        @if(specialty.id == specialtyId()) {
                        <div class="flex-column  align-center-center"
                            *ngFor="let medicalLicense of specialty.medicalLicenses">
                            @if(medicalLicense?.value > 0){
                            <div class="flex-column">

                                <div class="flex-row  align-center-center">
                                    <span class="card-text">
                                        {{ ('• ' + (medicalLicense?.type?.name || '') + ' Nº ') }}
                                    </span>
                                    <span class="card-text mls-1 text-primary-darker">
                                        {{ (medicalLicense?.value || '') | titlecase }}
                                    </span>
                                    <button (click)="copyToClipboard(medicalLicense?.value);$event.stopPropagation()"
                                        style="background-color: transparent; border: none; cursor: pointer;">
                                        <mat-icon [style.width.px]="12" [style.height.px]="12"
                                            svgIcon="copy"></mat-icon>
                                    </button>
                                </div>

                                <a class=" flex-100 card-text no-style-link text-primary-darker"
                                    href="https://sisa.msal.gov.ar/sisa/#sisa" target="_blank">
                                    <u>{{ 'modules.providers.map.verificar-matricula-sisa' | exp:'':'Verificar Matrícula (Sisa)' }}</u>
                                </a>

                            </div>
                            }
                        </div>
                        }
                    </ng-container>
                </div>
            </div>
            <!-- ACTION BUTTONS -->

            <div class="flex-row gap-1em">
                <div class="action-btn" role="button" tabindex="0" (click)="goToProviderSchedule(marker)">
                    <mat-icon svgIcon="calendar-primary" class="actions-btns-small"></mat-icon>
                    <span class="subtitle-6 text-primary-darker">{{('modules.providers.map.agenda' | exp:'':'Agenda') }}</span>
                </div>

                <div (click)="showProviderNewTab(marker, true)" class="action-btn">
                    <mat-icon svgIcon="user" class="actions-btns-small"></mat-icon>
                    <span  class="subtitle-6 text-primary-darker">{{('modules.providers.map.pacientes' | exp:'':'Pacientes') }}</span>
                </div>

                <div class="action-btn" role="button" tabindex="0" (click)="openReadOnly(marker)">
                    <mat-icon svgIcon="user-docs-primary" class="actions-btns-small"></mat-icon>
                    <span class="subtitle-6 text-primary-darker">{{('modules.providers.map.doc' | exp:'':'DOC')}}</span>
                </div>
            </div>

            <!-- ADDRESS -->
            <span class="card-text text-body">
                {{!!marker?.address ? marker.address : ('modules.providers.map.sin-direccion' | exp:'':'Sin dirección')}}
            </span>
            <!-- // -->
            <div class="flex-row align-center-center full-width gap-0-5em">
                <!-- PHONE NUMBER -->
                <div class="flex-row  flex-40 align-center-center gap-0-25em"
                    matTooltip=" {{!!marker.phone ? marker.phone : null}}">
                    <mat-icon [style.width.px]="12" [style.height.px]="12" svgIcon="whatsappLight"></mat-icon>
                    @if(!!marker?.phone) {
                    <a class="no-style-link subtitle-4 text-ellipsis card-text"
                        [href]="'https://api.whatsapp.com/send/?phone=' + marker.phone + '&text&type=phone_number&app_absent=0'"
                        target="_blank"> {{ marker.phone}}
                    </a>
                    }@else{
                    <span class="subtitle-4 text-ellipsis card-text "> {{ 'modules.providers.map.sin-telefono' | exp:'':'Sin teléfono' }}</span>
                    }
                </div>
                <!-- EMAIL -->
                <div class="flex-row flex-60  align-center-center gap-0-25em"
                    matTooltip=" {{!!marker?.email ? marker.email : null}}">
                    <mat-icon [style.width.px]="12" [style.height.px]="12" svgIcon="mailLight"></mat-icon>
                    <a class="no-style-link subtitle-4 text-ellipsis card-text " href="mailto:{{marker?.email}}"
                        target="_blank">
                        {{!!marker?.email ? marker.email : ('modules.providers.map.sin-email' | exp:'':'Sin email')}}
                    </a>
                </div>
                <!-- // -->
            </div>

        </div>
    </div>
</ng-template>

<!-- Patient -->
<ng-template #templatePatient let-marker>
    <div class="card-marker overflowH" style="padding: 10px !important;">
        <div class="header-line text-center full-width pts-1 mbs-1 pbs-1">
            <!-- NAME -->
            <div class="flex-row flex-100 align-center-center gap-1em">
                <span class="provider-state-chip flex-20" matTooltip="{{patientStatusTags[marker.status]}}"
                    [ngStyle]="{'color': PROVIDERS_STATUS_COLORS[marker.status], 'background-color': PROVIDERS_STATUS_BACKGROUND_COLORS[marker.status]}">
                    {{getStateLetter(marker.status)}}
                </span>
                <span class="card-text-primary flex-1 name" style="font-weight: 500; color: var(--color-primary-darker);">{{!!marker?.name
                    ? marker.name : ('modules.providers.map.sin-nombre' | exp:'':'Sin nombre')}}</span>
            </div>

        </div>
        <div class="flex flex-column align-center-center card-width text-center gap-0-5em">
            <div class="flex-column gap-0-5em align-center-center">
                <!-- DNI -->
                <span class="card-text text-body">{{('modules.providers.map.dni' | exp:'':'DNI')}} {{marker?.dni}}</span>
                <!-- TYPE -->
                <span class="card-text text-secondary-darker"> {{'modules.providers.map.paciente' | exp:'':'Paciente'}}</span>
                <!-- Go to Case -->
                <div (click)="openExternalUrl(marker)" class="action-btn" style="max-width: fit-content !important;">
                    <mat-icon svgIcon="user-list" class="actions-btns-small"></mat-icon>
                    <span class="subtitle-6 text-primary-darker">{{ 'modules.providers.map.ir-al-caso' | exp:'':'Ir al caso' }}</span>
                </div>
                <!-- ADDRESS -->
                <span class="card-text text-body">
                    {{!!marker?.address ? marker.address : ('modules.providers.map.sin-direccion' | exp:'':'Sin dirección')}}
                </span>
            </div>

            <!-- PHONE NUMBER -->
            <!-- <div class="flex-row align-center-center gap-0-5em">
                <mat-icon [style.width.px]="12" [style.height.px]="12" svgIcon="whatsappLight"></mat-icon>
                <a class="card-text no-style-link"
                    [href]="'https://api.whatsapp.com/send/?phone=' + marker.phone + '&text&type=phone_number&app_absent=0'"
                    target="_blank">
                    {{!!marker.phone ? marker.phone :'Sin teléfono'}}
                </a>
            </div> -->
            <!-- EMAIL -->
            <!-- <div class="flex-row gap-0-5em align-center-center mail-container ">
                <mat-icon [style.width.px]="12" [style.height.px]="12" svgIcon="mailLight"></mat-icon>
                <a class="card-text no-style-link text-ellipsis pls-0-7 " href="mailto:{{marker?.email}}"
                    target="_blank">
                    {{!!marker?.email ? marker.email : 'Sin email'}}
                </a>
            </div> -->
        </div>
    </div>
</ng-template>

<!-- Case -->
<ng-template #templateCase let-marker>
    <div class="card-marker">
        <div class="header-line text-center full-width">
            <!-- NAME -->
            <span class="text-primary">{{!!marker?.name ? marker.name : ('modules.providers.map.sin-nombre' | exp:'':'Sin nombre')}}</span>
        </div>
        <div class="flex flex-column align-center-center card-width text-center">
            <!-- ADDRESS -->
            <span class="text-black">
                {{!!marker?.address ? marker.address : ('modules.providers.map.sin-direccion' | exp:'':'Sin dirección')}}
            </span>
            <!-- PHONE NUMBER -->
            <div class="flex-row align-center-center gap-0-5em">
                <mat-icon [style.width.px]="16" [style.height.px]="16" svgIcon="whatsappLight"></mat-icon>
                <a class="no-style-link"
                    [href]="'https://api.whatsapp.com/send/?phone=' + marker.phone + '&text&type=phone_number&app_absent=0'"
                    target="_blank">
                    {{!!marker.phone ? marker.phone : ('modules.providers.map.sin-telefono' | exp:'':'Sin teléfono')}}
                </a>
            </div>
            <!-- EMAIL -->
            <!-- <div class="mail" > -->
            <div class="flex-row gap-0-5em align-center-center mail-container ">
                <mat-icon [style.width.px]="18" [style.height.px]="18" svgIcon="mailLight"></mat-icon>
                <a class="no-style-link text-ellipsis pls-0-7 " href="mailto:{{marker?.email}}" target="_blank">
                    {{!!marker?.email ? marker.email : ('modules.providers.map.sin-email' | exp:'':'Sin email')}}
                </a>
            </div>
            <!-- </div> -->
        </div>
    </div>
</ng-template>

<!-- Cluster-->
<ng-template #templateCluster let-marker let-members="members">
    <div class="card-marker" style="min-height: 280px; max-height: 280px; min-width: 350px">
        <div class="header-filter">
            <!-- Prestadores -->
            @if(findPatientsOnCluster(members) && findProvidersOnCluster(members)) {
            <div class="cluster-toggle-wrapper flex-row align-center-center">
                <span class="toggle-label" [class.active]="showingProviders">
                    {{'modules.providers.map.prestadores' | exp:'':'Prestadores'}}
                </span>

                <mat-slide-toggle class="cluster-slide-toggle" [color]="'primary'" [checked]="showingProviders"
                    (change)="onToggleProviders($event.checked)" disableRipple></mat-slide-toggle>

                <span class="toggle-label" [class.active]="!showingProviders">
                    {{'modules.providers.map.pacientes' | exp:'':'Pacientes'}}
                </span>
            </div>
            }@else if(findProvidersOnCluster(members)) {
            <div class="cluster-toggle-wrapper flex-row align-center-center">
                <span class="toggle-label" [class.active]="showingProviders">
                    {{'modules.providers.map.prestadores' | exp:'':'Prestadores'}}
                </span>
            </div>
            }@else if (findPatientsOnCluster(members)) {
            <div class="cluster-toggle-wrapper flex-row align-center-center">
                <span class="toggle-label" [class.active]="!showingProviders">
                    {{'modules.providers.map.pacientes' | exp:'':'Pacientes'}}
                </span>
            </div>
            }
        </div>

        <ng-container *ngTemplateOutlet=" activeClusterTemplate ; context: { $implicit: marker, members: members }">
        </ng-container>
    </div>
</ng-template>

<ng-template #clusterProvidersTemplate let-marker let-members="members">
    <ng-container *ngFor="let m of members">
        @if(providerTypes.includes(m.type) && m.visible) {
        <div class="item-header" style="min-width: 350px; overflow: hidden;" id="detail-{{m.id}}" tabindex="0">
            <!-- HEADER -->
            <div class="flex-100 flex-row align-start-center gap-0-5em prs-3" [ngClass]="{ 'selected': m.selected}">
                <!-- status chip 10% -->
                <span class="cluster-state-chip col-10 flex-center"
                    matTooltip="{{providerStatusTags[m.status]}}"
                    [ngStyle]="{ 'color': PROVIDERS_STATUS_COLORS[m.status], 'background-color': PROVIDERS_STATUS_BACKGROUND_COLORS[m.status]}">
                    {{ getStateLetter(m.status) }}
                </span>

                <!-- name 45% -->
                <span class="provider-name col-50 ellipsis text-black cursor-pointer" (click)="showProviderNewTab(m)">
                    {{ m.name || ('modules.providers.map.sin-nombre' | exp:'':'Sin nombre') }}
                </span>

                <!-- dni 25% -->
                <div class="flex-row col-25 align-start-center gap-1em">
                    <span class="col-20 text-primary" style=" font-size: 12px">
                        {{('modules.providers.map.dni' | exp:'':'DNI')}}
                    </span>
                    <span class="col-80 ellipsis text-black" style=" font-size: 12px;">
                        {{ m.dni || ('modules.providers.map.sin-documento' | exp:'':'Sin documento') }}
                    </span>
                </div>

                <!-- expand + actions (20%) -->
                <div class="flex-row col-10 gap-0-5em pls-3">
                    <mat-icon (click)="toggleMember(m)" class="col-50 flex-center">
                        {{ expandedMemberId === m.id ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                    <!-- <mat-icon class="col-50 flex-center">
                        more_vert
                    </mat-icon> -->
                </div>
            </div>

            <!-- DETALLE EXPANDIDO -->
            <div *ngIf="expandedMemberId === m.id" class="item-detail" id="detail-{{m.id}}" tabindex="0">
                <div class="card-marker overflowH p-2">
                    <!-- encabezado detalle -->
                    <div class="header-line full-width mbs-1 text-center" style="padding:0.4rem 0 0.2rem; ">
                        <div class="flex-row align-end-center" [matTooltip]="m.observations?.trim() || ('modules.providers.map.sin-observaciones' | exp:'':'Sin observaciones')">
                            <span class="card-text-secondary "
                                [ngStyle]="{ 'color': m.observations?.trim() ? 'var(--color-map-alert)' : 'var(--color-grey-medium)' }">
                                {{('modules.providers.map.observaciones' | exp:'':'Observaciones') }}
                            </span>
                            <mat-icon [style.width.px]="12" [style.height.px]="12" [svgIcon]="'Notepad'"
                                [ngStyle]="{ 'color': m.observations?.trim() ? 'var(--color-map-alert)' : 'var(--color-grey-medium)' }">
                            </mat-icon>
                        </div>
                    </div>

                    <!-- cuerpo detalle -->
                    <div class="flex flex-column align-center-center card-width text-center gap-0-5em">

                        <!-- DNI, especialidad y matrículas -->
                        <div class="flex-column gap-0-25em">
                            <!-- <span class="card-text" style="color:black;">
                        DNI {{ m.dni }}
                      </span> -->
                            <!-- SPECIALTY -->
                            <span class="card-text">{{specialtyName()}}</span>
                            <!-- MEDICAL LICENSE -->
                            <div class="container">
                                <ng-container *ngFor="let specialty of m?.specialties">
                                    @if(specialty.id == specialtyId()) {
                                    <div class="row-wrap align-center-center"
                                        *ngFor="let medicalLicense of specialty.medicalLicenses">
                                        @if(medicalLicense?.value > 0){
                                        <span class="card-text">
                                            {{ ('• ' + (medicalLicense?.type?.name || '') + ' Nº ') }}
                                        </span>
                                        <span class="card-text mls-1 text-primary-darker">
                                            {{ (medicalLicense?.value || '') | titlecase }}
                                        </span>
                                        <button
                                            (click)="copyToClipboard(medicalLicense?.value);$event.stopPropagation()"
                                            style="background-color: transparent; border: none; cursor: pointer;">
                                            <mat-icon [style.width.px]="12" [style.height.px]="12"
                                                svgIcon="copy"></mat-icon>
                                        </button>
                                        <a class=" flex-100 card-text no-style-link text-primary-darker"
                                            href="https://sisa.msal.gov.ar/sisa/#sisa" target="_blank">
                                            <u>{{ 'modules.providers.map.verificar-matricula-sisa' | exp:'':'Verificar Matrícula (Sisa)' }}</u>
                                        </a>
                                        }
                                    </div>
                                    }
                                </ng-container>
                            </div>

                            <div class="flex-row gap-1em">
                                <div class="action-btn" role="button" tabindex="0" (click)="goToProviderSchedule(m)">
                                    <mat-icon svgIcon="calendar-primary" class="actions-btns-small"></mat-icon>
                                    <span class="subtitle-6 text-primary-darker">{{('modules.providers.map.agenda' | exp:'':'Agenda') }}</span>
                                </div>

                                <div (click)="showProviderNewTab(m, true)" class="action-btn">
                                    <mat-icon svgIcon="user" class="actions-btns-small"></mat-icon>
                                    <span class="subtitle-6 text-primary-darker">{{('modules.providers.map.pacientes' | exp:'':'Pacientes') }}</span>
                                </div>

                                <div class="action-btn" role="button" tabindex="0" (click)="openReadOnly(m)">
                                    <mat-icon svgIcon="user-docs-primary" class="actions-btns-small"></mat-icon>
                                    <span class="subtitle-6 text-primary-darker">{{('modules.providers.map.doc' | exp:'':'DOC')}}</span>
                                </div>
                            </div>

                        </div>

                        <!-- dirección -->
                        <span class="card-text text-body">
                            {{ m.address || ('modules.providers.map.sin-direccion' | exp:'':'Sin dirección') }}
                        </span>

                        <!-- bottom detail info -->
                        <div class="flex-row align-center-center full-width gap-2em">
                            <!-- teléfono -->
                            <div class="flex-row align-center-center gap-0-5em">
                                <mat-icon svgIcon="whatsappLight" [style.width.px]="12"
                                    [style.height.px]="12"></mat-icon>
                                <a class="card-text no-style-link"
                                    [href]="'https://api.whatsapp.com/send/?phone=' + m.phone + '&text&type=phone_number'"
                                    target="_blank">
                                    {{ m.phone ||  ('modules.providers.map.sin-telefono' | exp:'':'Sin teléfono') }}
                                </a>
                            </div>

                            <!-- email -->
                            <div class="flex-row align-center-center gap-0-5em">
                                <mat-icon svgIcon="mailLight" [style.width.px]="12" [style.height.px]="12"></mat-icon>
                                <a class="card-text no-style-link ellipsis full-width" href="mailto:{{ m.email }}"
                                    target="_blank">
                                    {{ m.email || ('modules.providers.map.sin-email' | exp:'':'Sin email') }}
                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>
        }
        @if(patientTypes.includes(m.type)) {
        <div class="item-header" style="min-width: 350px; overflow: hidden;" id="detail-{{m.id}}">
            <!-- HEADER -->
            <!-- HEADER -->
            <div class="flex-100 flex-row align-start-center gap-0-5em prs-3">
                <!-- status chip 10% -->
                <span class="cluster-state-chip col-10 flex-center"
                    matTooltip="{{patientStatusTags[m.status]}}"
                    [ngStyle]="{ 'color': PROVIDERS_STATUS_COLORS[m.status], 'background-color': PROVIDERS_STATUS_BACKGROUND_COLORS[m.status]}">
                    {{ getStateLetter(m.status) }}
                </span>

                <!-- name 45% -->
                <span class="provider-name col-50 ellipsis text-black">
                    {{ m.name || ('modules.providers.map.sin-nombre' | exp:'':'Sin nombre') }}
                </span>


                <!-- dni 25% -->
                <div class="flex-row col-25 align-start-center gap-1em">
                    <span class="col-20 text-primary" style=" font-size: 12px">
                        {{('modules.providers.map.dni' | exp:'':'DNI')}}
                    </span>
                    <span class="col-80 ellipsis text-black" style=" font-size: 12px;">
                        {{ m.dni || ('modules.providers.map.sin-documento' | exp:'':'Sin documento') }}
                    </span>
                </div>

                <!-- expand + actions (20%) -->
                <div class="flex-row col-10 gap-0-5em pls-3">
                    <mat-icon (click)="toggleMember(m)" class="col-50 flex-center">
                        {{ expandedMemberId === m.id ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                    <!-- <mat-icon class="col-50 flex-center">
                                more_vert
                            </mat-icon> -->
                </div>
            </div>

            <!-- DETALLE EXPANDIDO -->
            <div *ngIf="expandedMemberId === m.id" class="item-detail" id="detail-{{m.id}}" tabindex="0">
                <div class="card-marker overflowH" style="padding:10px;">
                    <!-- cuerpo detalle -->
                    <div class="flex flex-column align-center-center card-width text-center gap-0-5em">
                        <div class="flex flex-column align-center-center card-width text-center gap-0-5em">
                            <!-- ADDRESS -->
                            <span class="card-text text-body">
                                {{!!m?.address ? m.address : ('modules.providers.map.sin-direccion' | exp:'':'Sin dirección')}}
                            </span>
                            <!-- PHONE NUMBER -->
                            <div class="flex-row align-center-center gap-0-5em">
                                <mat-icon [style.width.px]="12" [style.height.px]="12"
                                    svgIcon="whatsappLight"></mat-icon>
                                <a class="card-text no-style-link"
                                    [href]="'https://api.whatsapp.com/send/?phone=' + m.phone + '&text&type=phone_number&app_absent=0'"
                                    target="_blank">
                                    {{!!m.phone ? m.phone : ('modules.providers.map.sin-telefono' | exp:'':'Sin teléfono')}}
                                </a>
                            </div>
                            <!-- EMAIL -->
                            <div class="flex-row gap-0-5em align-center-center mail-container ">
                                <mat-icon [style.width.px]="12" [style.height.px]="12" svgIcon="mailLight"></mat-icon>
                                <a class="card-text no-style-link text-ellipsis pls-0-7 " href="mailto:{{m?.email}}"
                                    target="_blank">
                                    {{!!m?.email ? m.email : ('modules.providers.map.sin-email' | exp:'':'Sin email')}}
                                </a>
                            </div>
                            <!-- GO TO CASE -->
                            <div (click)="openExternalUrl(m)" class="action-btn" style="max-width: fit-content !important">
                                <mat-icon svgIcon="user-list" class="actions-btns-small"></mat-icon>
                                <span class="subtitle-6 text-primary-darker">{{ 'modules.providers.map.ir-al-caso' | exp:'':'Ir al caso' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </ng-container>
</ng-template>


<ng-template #providerDSPHost>
    <ng-container *ngComponentOutlet="providersManagementCmp; injector: dspInjector">
    </ng-container>
</ng-template>
